import { IconName } from '../../../../React/Common/Components/Icon'

/**
 * Stable identifiers for each Administration overview tile.
 */
export enum AdminOverviewTileID {
    CME = 'cme',
    TELSYS = 'telsys',
    PARTITIONS = 'partitions',
    USERS = 'users',
    DEVICES = 'devices',
    AGENTS = 'agents',
    DIRECTORY = 'directory',
    CODES = 'codes',
    RECORDING = 'recording'
}

/**
 * Loading and availability states rendered by the Administration overview tiles.
 */
export enum AdminOverviewTileState {
    READY = 'ready',
    LOADING = 'loading',
    ERROR = 'error',
    NEEDS_SCOPE = 'needsScope'
}

/**
 * Additional contextual metadata rendered alongside a tile's main total.
 */
export type AdminOverviewTileAdditionalInfo = {
    readonly label: string
    readonly value: string
}

/**
 * Router link destination for an Administration overview tile.
 */
export type AdminOverviewTileRouterDestination = {
    readonly to: string
    readonly href?: never
}

/**
 * Legacy servlet link destination for an Administration overview tile.
 */
export type AdminOverviewTileLegacyDestination = {
    readonly href: string
    readonly to?: never
}

/**
 * Tile with no navigation target (hidden or disabled).
 */
export type AdminOverviewTileNoDestination = Record<string, never>

/**
 * Supported navigation target shapes for an Administration overview tile.
 */
export type AdminOverviewTileDestination =
    | AdminOverviewTileRouterDestination
    | AdminOverviewTileLegacyDestination
    | AdminOverviewTileNoDestination

/**
 * Render model for a single Administration overview tile.
 */
export type AdminOverviewTileViewModel = AdminOverviewTileDestination & {
    readonly id: AdminOverviewTileID
    readonly title: string
    readonly subtitle: string
    readonly ariaLabel: string
    readonly icon: IconName
    readonly visible: boolean
    readonly enabled: boolean
    readonly state: AdminOverviewTileState
    readonly value?: string
    readonly summary: string
    readonly additionalInfo: readonly AdminOverviewTileAdditionalInfo[]
}
